export const HOSTNAME = "https://" + window.location.host;
export const API_URL = `${HOSTNAME}/moodbuster-patient-service`;

export const version = "1.9.5"; // this will be updated temporarilly when running 'npm run build'

export const docs: any = {
  appPath: (lang: string) => {
    console.log(lang);
    return null;
  },
  websitePath: (lang: string) => {
    return `/docs/${lang}/moodbuster2_website_portal_manual.pdf`;
  },
  videoPath: () => {
    return "https://video.inesctec.pt/AVideo/vEmbed/58";
  }
};

// Do not change EVENTS_COLORS without making the necessary changes on the API
export const EVENTS_COLORS: any = {
  blue: {
    primary: "#0000CD",
    secondary: "#0000FF",
    value: 6,
    name: "blue"
  },
  green: {
    primary: "#32CD32",
    secondary: "#00FF00",
    value: 4,
    name: "green"
  },
  lightblue: {
    primary: "#00BFFF",
    secondary: "#87CEFA",
    value: 7,
    name: "lightblue"
  },
  lightyellow: {
    primary: "#FFFACD",
    secondary: "#FFFFE0",
    value: 9,
    name: "lightyellow"
  },
  orange: {
    primary: "#FF8C00",
    secondary: "#FFA500",
    value: 2,
    name: "orange"
  },
  purple: {
    primary: "#9400D3",
    secondary: "#9370DB",
    value: 8,
    name: "purple"
  },
  red: {
    primary: "#FF0000",
    secondary: "#FF4500",
    value: 1,
    name: "red"
  },
  turquoise: {
    primary: "#00CED1",
    secondary: "#40E0D0",
    value: 5,
    name: "turquoise"
  },
  yellow: {
    primary: "#FFD700",
    secondary: "#FFFF00",
    value: 3,
    name: "yellow"
  }
};

export const INVALID_PASSWORD_REGEX = new RegExp(
  /^(.{0,7}|[^0-9]*|[^A-Z]*|[^a-z]*|[a-zA-Z0-9]*)$/
);

const allowIframesFrom = [
  'youtube.com',
  'video.inesctec.pt',
  'player.vimeo.com',
  'vu.cloud.panopto.eu'
];

export const allowIframesInfo = {
  endpoint: {
    method: 'get',
    url: /\/moodbuster-patient-service\/patients\/[0-9]+\/pages\/[0-9]+/
  }, // eslint-disable-next-line no-useless-escape
  srcRegexPattern: new RegExp(`^https:\/\/(?:www\\.)?(${allowIframesFrom.map(url => `(?:${url.replace(/\//g, '\\/')})`).join('|')})\/`),
  domPurifyconfig: {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allowfullscreen', 'frameborder', 'width', 'height', 'target']
  }
};
